/**
 * Preferences Page
 * Online booking preferences: time restrictions, booking flow, multiple services, a link to
 * Same-time services (Settings › Services), Hayven service photos, and the always-on smart
 * scheduling rules
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { TimeRestrictionsCard } from './online-booking/components/time-restrictions-card'
import { TechnicianFlowChoiceCard } from './online-booking/components/technician-flow-choice-card'
import { ServiceBookingOptionsCard } from './online-booking/components/service-booking-options-card'
import { SameTimeServicesLinkRow } from './online-booking/components/same-time-services-link-row'
import { HayvenPhotosCard } from './online-booking/components/hayven-photos-card'
import { SmartSchedulingInfoCard } from './online-booking/components/smart-scheduling-info-card'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/settings/online-booking/preferences')({
  component: PreferencesPage,
})

function PreferencesPage() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/online-booking/preferences' })

  // The page opens only with Calendar on (route guard), where Hayven online booking can always be on.
  const settingsCards = (
    <>
      <TimeRestrictionsCard />
      <TechnicianFlowChoiceCard />
      <ServiceBookingOptionsCard />
      <SameTimeServicesLinkRow routeOrgId={orgId} />
      <HayvenPhotosCard />
      <SmartSchedulingInfoCard />
    </>
  )

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Preferences', 'Online Booking')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="preferences">
        <SettingsPageHeader
          title="Preferences"
          description="Control how clients book with you online."
        />

        <div className="space-y-6 max-w-2xl">
          {settingsCards}
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
